import React from 'react';
import { Text } from '@simplybenefits/sb-ui-library';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { 
    Add as AddIcon, 
    Remove as RemoveIcon 
} from '@mui/icons-material';

/**
 *
 * @param {*} props
 */
export default function FinancialAwareness({ classes, expanded, financialAwareness, handleChange }) {
    return (
        <div style={ classes.block }>
            <Accordion
                square
                onChange={handleChange('financialAwareness')}
                style={{ boxShadow: 'none' }}
                disableGutters={true}
            >
                <AccordionSummary
                    classes={{
                        content: classes.panelContent,
                        expanded: classes.expanded,
                        root: classes.root
                    }}
                    sx={classes.accordionSummary}
                    expandIcon={expanded.includes('financialAwareness') ? <RemoveIcon /> : <AddIcon />}
                >
                    <Text medium bold>Financial Awareness</Text>
                </AccordionSummary>
                <AccordionDetails style={classes.panelDetails}>
                    {
                        financialAwareness.isEligible === 1 ?
                            <React.Fragment>
                                {
                                    financialAwareness.includeEnrichedAcademy === 1 &&
                                    <>
                                        <Text small margin="20px 0px 0px 0px">
                                            { `Enriched Academy is a Financial Awareness program that aims to improve health & well-being by reducing financial stress. EA provides Canadians in all stages of life with learning tools and personal support to empower financial literacy. Access to this product can be provided by a company as a form of employee assistance to benefit both the employer and employees.` }
                                        </Text>
                                        <Text small margin="20px 0px 10px 0px">
                                            { `Enriched Academy is available online for desktop and mobile.` }
                                        </Text>
                                        <ul style={{ listStyle: 'disc', paddingLeft: '16px', marginLeft: '1px' }}>
                                            <li><Text small margin="0px 0px 0px 0px"> Online, self-guided, program with tools, calculators and resources for building financial wellness.</Text></li>
                                            <li><Text small margin="5px 0px 0px 0px"> Live and recorded virtual training sessions with Q&A.</Text></li>
                                            <li><Text small margin="5px 0px 0px 0px"> 1:1 Financial Coaching with Enriched Academy’s unbiased Accredited Financial Coaches or Certified Financial Planners.</Text></li>
                                            <li><Text small margin="5px 0px 0px 0px"> In-person training opportunities.</Text></li>
                                        </ul>
                                    </>
                                }
                            </React.Fragment>
                            :
                            <div style={classes.row}>
                                <Text small bold margin="20px 0px 10px 0px">
                                You are currently ineligible for this benefit, if this is a mistake please contact your administrator.
                                </Text>
                            </div>
                    }
                </AccordionDetails>
            </Accordion>
        </div>
    );
}